const googleAnalyticsId = `UA-17355070-1`;

module.exports = {
  pathPrefix: `/seattle`,
  siteMetadata: {
    title: `Seattle In Context`,
    description: `Explore Downtown Seattle. Block by block.`,
    author: `@vlandham`,
    googleAnalyticsId,
    mapboxToken: process.env.GATSBY_MAPBOX_API_TOKEN
  },
  plugins: [
    `gatsby-plugin-react-helmet`,
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: `seattle-in-context`,
        short_name: `seattle`,
        start_url: `/`,
        background_color: `#ffffff`,
        theme_color: `#4dc0b5`,
        display: `minimal-ui`,
        icon: `src/images/icon.png`
      }
    },
    `gatsby-plugin-postcss`,
    {
      resolve: `gatsby-plugin-purgecss`,
      options: {
        tailwind: true,
        purgeOnly: [`src/css/style.css`]
      }
    },
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    {
      resolve: `gatsby-transformer-remark`,
      options: {
        plugins: [
          {
            resolve: `gatsby-remark-images`,
            options: {
              maxWidth: 800
            }
          },
          {
            resolve: `gatsby-remark-number-headers`,
            options: {
              // Options here
            }
          }
        ]
      }
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `markdown-pages`,
        path: `${__dirname}/src/markdown`
      }
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `map-images`,
        path: `${__dirname}/src/maps`
      }
    },
    `gatsby-plugin-offline`,
    {
      resolve: `gatsby-plugin-google-analytics`,
      options: {
        trackingId: googleAnalyticsId
      }
    }
  ]
};
